export default {
	changePassword: {
		'Change Password': 'パスワードを変更',
		'Set Password': 'パスワードを設定',
	},
	profile: {
		绑定手机号: '携帯電話番号をバインドする',
		绑定邮箱: '電子メールをバインドする',
		裁剪人脸: '顔写真を切り抜き',
		裁剪要求: '切り抜き要件',
		查看认证信息: '表示',
		查看原因: '理由を表示',
		城市: '市',
		待审核: '審査待ち',
		当前: '現在',
		当前尺寸: '現在のサイズ',
		地址: '住所',
		点击认证: 'クリックして認証します',
		二要素认证: '二要素認証',
		二要素说明: '氏名と身分証番号が一致しているかを確認します',
		放大: '拡大',
		分辨率太低: '解像度が低すぎます。最低 480 × 640 ピクセルが必要です',
		更换手机号: '携帯電話番号を変更する',
		更换邮箱: 'メールアドレスを変更する',
		公司名称: '会社名',
		'国家/地区': '国/地域',
		基本信息: '基本情報',
		仅支持jpg_png_webp: 'jpg / png / webp 形式のみサポート',
		仅支持PNG_JPG_JPEG: 'PNG / JPG / JPEG 形式のみサポート',
		拒绝原因: '却下理由',
		开始扫脸认证: '顔認証を開始',
		请上传人脸图片: '顔写真をアップロードしてください',
		请填写18位身份证号: '身分証番号を入力してください',
		请填写本人实名手机号: '本人実名の携帯電話番号を入力してください',
		请填写有效的11位手机号: '有効な11桁の携帯電話番号を入力してください',
		请填写有效的18位身份证号: '有効な18桁の身分証番号を入力してください',
		请填写有效的手机号: '有効な携帯電話番号を入力してください',
		请填写真实姓名: '本名を入力してください',
		去认证: '認証へ',
		人脸说明:
			'PNG / JPG / JPEG 形式の本人正面写真をご用意ください（光線十分、遮るもの無し）。切り抜き後は 3:4 縦長で出力し、自動的に 1MB 以内に圧縮されます',
		人脸图片: '顔写真',
		认证成功: '認証成功',
		认证类型: '認証タイプ',
		认证失败: '認証失敗',
		认证信息: '認証情報',
		若窗口未自动打开请点击: 'ウィンドウが自動的に開かない場合はクリックしてください',
		三要素认证: '三要素認証',
		三要素说明: '氏名、身分証番号、携帯電話番号が一致しているかを確認します',
		扫脸初始化失败: '顔認証の初期化に失敗しました',
		扫脸认证: '顔認証',
		扫脸说明:
			'下のボタンをクリックすると、新しいウィンドウで Alibaba Cloud の顔認証ページが開きます。完了後、本ページに戻って「顔認証完了」をクリックしてください',
		扫脸跳转说明: '新しいウィンドウで顔認証ページを開きました。完了後、こちらに戻って「顔認証完了」をクリックしてください',
		身份证号: 'ID番号',
		审核不通过: '審査に通らなかった場合',
		审核中提示: '提出資料を審査中です。しばらくお待ちください',
		实名认证: '実名認証',
		实名认证信息: '実名認証情報',
		实时预览: 'リアルタイムプレビュー',
		手动打开扫脸页面: '顔認証ページを手動で開く',
		手机号: '携帯電話番号',
		缩小: '縮小',
		提升认证等级: 'クリックしてアップグレード',
		图片不能超过4MB: '画像サイズは 4MB を超えてはいけません',
		图片仍超过1MB请重新裁剪: '切り抜き後の画像が 1MB を超えています、再度範囲を縮小してください',
		未绑定: 'バインドされていません',
		未认证: '認定されていません',
		未填写: '未記入',
		我已完成扫脸: '顔認証完了',
		无拒绝原因: '管理者は却下理由を入力していません',
		姓名: '名前',
		修改基本信息: '基本情報の変更',
		修改信息: '情報の変更',
		要求: '要求',
		要求_大小: '切り抜き後、自動的に 1MB 以内に圧縮',
		要求_分辨率: '解像度 480×640 ～ 1080×1920',
		要求_格式: '形式：PNG / JPG / JPEG',
		要求_竖版: '高さ > 幅（3:4 縦長で自動ロック）',
		已绑定: 'バインドされています',
		已认证: '認定済み',
		邮箱: '郵便',
		邮箱更换成功提示: 'メールアドレスを変更しました。OK をクリックしてページを更新します。',
		邮箱未绑定: '電子メールはバインドされていません',
		邮箱已绑定: '電子メールはバインドされています',
		邮政编码: '郵便番号',
		右转: '右回転',
		语言: '言語',
		预估大小: '推定ファイルサイズ',
		原图不能超过10MB: '元画像は 10MB を超えてはいけません',
		重新认证: '再認定',
		重新填写: '再入力',
		重置: 'リセット',
		左转: '左回転',
	},
	城市: '市',
	当前密码: '現在のパスワード',
	地区: 'エリア',
	地址: '住所',
	地址信息: '住所情報',
	登录信息: 'ログイン情報',
	电话号码: '電話番号',
	电话前缀: '電話プレフィックス',
	电话前缀和手机号不能为空: '電話番号と携帯電話番号を空にすることはできません',
	发送: '送信',
	发送验证码: '確認コードを送信する',
	个人签名: 'パーソナライズされた署名',
	个人资料: '個人データ',
	更换: '交換する',
	更换邮箱: 'メールアドレスを変更する',
	公司名称: '会社名',
	关闭: '閉鎖',
	国家: '国家',
	'国家/地区': '国/地域',
	获取验证码: '確認コードを取得する',
	基本信息: '基本情報',
	旧密码: '以前のパスワード',
	联系方式: '連絡先',
	密码: 'パスワード',
	秒: '2番',
	名字: '名前',
	取消: 'キャンセル',
	'确定提交吗？': '本当に提出しますか?',
	确认密码: '確認パスワード',
	生日: '誕生日',
	手机号: '電話番号',
	提交: '提出する',
	退出登录: 'ログアウト',
	完成: '仕上げる',
	未验证: '未検証',
	下一步: '次のステップ',
	新密码: '新しいパスワード',
	新密码不能与旧密码相同: '新しいパスワードを古いパスワードと同じにすることはできません',
	确认密码与密码不一致: '確認用パスワードとパスワードが一致しません。',
	新邮箱地址: '新しいメールアドレス',
	新邮箱认证: '新規メール認証',
	新邮箱验证码: '新しいメール認証コード',
	信息认证: '情報認証',
	姓氏: '苗字',
	性别: '性別',
	修改或完善资料: '情報を変更または完成させる',
	验证: '確認する',
	验证码: '検証コード',
	已验证: '確認済み',
	邮箱地址: '電子メールアドレス',
	'邮箱更换成功，请退出系统重新登录': 'メールアドレスが正常に変更されました。システムからログアウトし、再度ログインしてください。',
	邮箱认证: 'メール認証',
	邮政编码: '郵便番号',
	语言: '言語',
	重复密码: 'パスワードを再度入力してください。',
	重复新密码: '新しいパスワードを繰り返します',
	最后登录时间: '最終ログイン時間',
	最后登录IP: '最終ログインIP',
}
